import {
  GET_ALL_COURSE_CLONES,
  GET_ALL_COURSE_CLONES_DETAILS,
} from "../constants";

export const initialState = {
  courseClones: undefined,
  courseCloneDetails: undefined,
};
export const CourseCloneReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_ALL_COURSE_CLONES: {
      return {
        ...state,
        courseClones: action.payload,
      };
    }

    case GET_ALL_COURSE_CLONES_DETAILS: {
      return {
        ...state,
        courseCloneDetails: action.payload,
      };
    }
    default:
      return state;
  }
};
